import { Children, PropsWithChildren, RefObject, useCallback, useEffect, useState } from 'react'

import { useSelection } from 'src/hooks/useSelection'

import { QUICK_ACTION_MENU_HEIGHT, QUICK_ACTION_MENU_OFFSET } from './constants'
import * as S from './styles'
import { QuickActionProvider } from './QuickActionContext'

type QuickActionMenuProps = PropsWithChildren<{
    containerWidth: number
    outerElementRef: RefObject<HTMLElement | null>
}>

export const QuickActionMenu = (props: QuickActionMenuProps) => {
    const { outerElementRef, children } = props
    const { selectedText, isWithinOuterElement, relativeRect } = useSelection(outerElementRef)

    const [isMenuVisible, setIsMenuVisible] = useState(false)
    const [coords, setCoords] = useState({ x: 0, y: 0 })

    useEffect(() => {
        const shouldMenuBeVisible = !!selectedText && isWithinOuterElement
        setIsMenuVisible(shouldMenuBeVisible)

        const x = Math.round((relativeRect.left + relativeRect.right) / 2)
        let y = relativeRect.top - QUICK_ACTION_MENU_HEIGHT - QUICK_ACTION_MENU_OFFSET
        if (y < 0) {
            y = relativeRect.bottom + QUICK_ACTION_MENU_OFFSET
        }
        setCoords({ x, y })
    }, [isWithinOuterElement, relativeRect, selectedText])

    const closeMenu = useCallback(() => {
        setIsMenuVisible(false)
    }, [])

    const hasRenderableChildren = Children.toArray(children).length > 0

    return (
        <QuickActionProvider selectedText={selectedText} closeMenu={closeMenu}>
            {isMenuVisible && hasRenderableChildren && (
                <S.Container data-appcues-quick-action-menu="quick-action-menu" $x={coords.x} $y={coords.y}>
                    {children}
                </S.Container>
            )}
        </QuickActionProvider>
    )
}
